// extracted by mini-css-extract-plugin
export var arrows = "_5c-5";
export var decrementer = "_5c-9";
export var disabled = "_5c-3";
export var error = "_5c-1";
export var hiddenText = "_5c-a";
export var incrementer = "_5c-8";
export var input = "_5c-7";
export var inputWrapper = "_5c-0";
export var leadingIcon = "_5c-b";
export var readonly = "_5c-2";
export var regular = "_5c-6";
export var small = "_5c-4";